import areaRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  storageHandler,
  toaster,
  $$railway,
  $$area
) => {
  $transitions.onSuccess({
    entering: areaRoutes.new.path,
  }, (trans) => {
    if (storageHandler.get('consult.area.new')) {
      $$area.data.myArea = storageHandler.get('consult.area.new')
    } else {
      $$area.data.myArea = $$area.new()
    }
  })

  $transitions.onBefore({
    from: areaRoutes.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.area.new', $$area.data.myArea)
      $$area.data.myArea = null
    }
  })

  $transitions.onSuccess({
    entering: areaRoutes.home.path,
  }, async (trans) => {
    try {
      const response = await $$area.request.getAll()
      $$area.data.myAreas = response.areas
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: areaRoutes.home.path,
  }, async (trans) => {
    $$area.data.myAreas.splice(0, $$area.data.myAreas.length)
  })

  $transitions.onSuccess({
    entering: areaRoutes.details.path,
  }, async (trans) => {
    const areaId = $$area.local.getCurrentId()

    try {
      const myArea = $$area.request.getById(areaId)
      const myRailways = $$railway.request.getByArea(areaId)

      const [area, railways] = await Promise.all([myArea, myRailways])

      console.log('area', area)
      console.log('railways', railways)

      $$area.data.myArea = area
      $$railway.data.myRailways = railways
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: areaRoutes.details.path,
  }, async (trans) => {
    $$area.data.myArea = null
    $$railway.data.myRailways = null
  })

  $transitions.onSuccess({
    entering: areaRoutes.edit.path,
  }, async (trans) => {
    const areaId = $$area.local.getCurrentId()
    try {
      const area = await $$area.request.getById(areaId)
      $$area.data.myArea = area
      $$area.data.myArea.oldValue = area.name
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: areaRoutes.edit.path,
  }, async (trans) => {
    $$area.data.myArea = null
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/area/area.run.js